import type { InvestorCommunicationType } from "../../../../../../api/types/investorCommunicationsTypes";

interface EngagementLabels {
  avgDepthTitle: string;
  avgDepthCaption: string;
  avgTimeTitle: string;
  completedLabel: string;
  openedNotCompletedLabel: string;
  viewedLabel: string;
  timeSpentLabel: string;
}

export const investorCommunicationEngagementLabels: Record<InvestorCommunicationType, EngagementLabels> = {
  Article: {
    avgDepthTitle: "Avg read depth",
    avgDepthCaption: "of article read",
    avgTimeTitle: "Avg read time",
    completedLabel: "Read fully",
    openedNotCompletedLabel: "Opened, not read fully",
    viewedLabel: "Viewed",
    timeSpentLabel: "read",
  },
  Video: {
    avgDepthTitle: "Avg watch depth",
    avgDepthCaption: "of video watched",
    avgTimeTitle: "Avg watch time",
    completedLabel: "Watched fully",
    openedNotCompletedLabel: "Opened, not watched fully",
    viewedLabel: "Watched",
    timeSpentLabel: "watched",
  },
};
